export const FETCH_IS_LOADING = 'FETCH_IS_LOADING';
export const SET_HAS_ERROR = 'SET_HAS_ERROR';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const UNSET_NOTIFICATION = 'UNSET_NOTIFICATION';

export const setIsLoading = req => async dispatch => {
    dispatch({ type: FETCH_IS_LOADING, payload: req });
};

export const setHasError = () => dispatch => {
    dispatch({ type: SET_HAS_ERROR});
};

export const setNotification = req => dispatch => {
    dispatch({ type: SET_NOTIFICATION, payload: req });
};

export const unsetNotification = req => dispatch => {
    dispatch({ type: UNSET_NOTIFICATION });
};
